import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const ProcessOverview = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData =
    labels.menuPages?.sellCar?.testSection?.processOverview || {};
  const stepsData = sectionData.steps || [];

  return (
    <div className="bg-gradient-to-br from-emerald-500 via-teal-600 to-cyan-700 rounded-3xl p-12 mb-16 text-white shadow-2xl">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <h3 className="text-3xl font-bold mb-6">
            {sectionData.title || "Så Fungerar Vårt Test"}
          </h3>
          <div className="space-y-4">
            {stepsData.map((step: any, index: number) => (
              <div key={index} className="flex items-start">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-4 mt-1">
                  <span className="text-sm font-bold">{index + 1}</span>
                </div>
                <div>
                  <h4 className="text-lg font-semibold mb-2">
                    {step.title || ""}
                  </h4>
                  <p className="opacity-90">{step.description || ""}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <img
            src="/assets/test_example.png"
            alt="Fordonstestrapport med transparent dokumentation"
            className="w-full h-auto rounded-2xl shadow-lg"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};
export default ProcessOverview;
